import { isSet } from 'rise-ui/utils/nullish.js';

export const TRUE = ' ';
export const FALSE = '';

/**
 * Returns last value if all values are truthy
 * @param {*[]} values
 * @return {string} Last value or empty string
 */
export function and(...values) {
  let v = TRUE;
  values.every(p => v = p);
  return v;
}

/**
 * Returns first truthy value
 * @param {*[]} values
 * @return {string} First truthy value or empty string
 */
export function or(...values) {
  let v = TRUE;
  return values.some(p => v = p) ? v : FALSE;
}

/**
 * Returns first set value (e.g. '' and 0 are falsey, but "set")
 * @param {*[]} values
 * @return {string} First set value or empty string
 */
export function one(...values) {
  let v = TRUE;
  return values.some(p => (v = p, isSet(v))) ? v : FALSE;
}

export function compareEvery(fn, ...values) {
  const v = values[0];
  while (values.length) {
    const v = values.shift();
    for (let i = 0; i < values.length; ++i) {
      if (!fn(v, values[i])) {
        return FALSE;
      }
    }
  }
  return v || TRUE;
}

export function eq(...values) {
  // jshint eqeqeq: false
  return compareEvery((p, c) => p == c
    || Number.isNaN(p) && Number.isNaN(c)
    || p && c && p.length === 0 && c.length === 0
    || p instanceof Date && c instanceof Date && p.getTime() === c.getTime()
  , ...values);
}

export function streq(...values) {
  return compareEvery((p, c) => p === c, ...values);
}

export function neq(...values) {
  // jshint eqeqeq: false
  return compareEvery((p, c) => p != c, ...values);
}

export function strneq(...values) {
  return compareEvery((p, c) => p !== c, ...values);
}

export function pipeEvery(fn, ...values) {
  return values.every((p, i) => !i || fn(values[i - 1], p))
    ? values[0] || TRUE : FALSE;
}

export function lt(...values) {
  return pipeEvery((p, c) => p < c, ...values);
}

export function lte(...values) {
  return pipeEvery((p, c) => p <= c, ...values);
}

export function gt(...values) {
  return pipeEvery((p, c) => p > c, ...values);
}

export function gte(...values) {
  return pipeEvery((p, c) => p >= c, ...values);
}
